'use client'

import { FACULTY_BG } from '@/components/RevampedLanding/contants'
import { FacultyProps } from '@/widgets/landing-page-widgets/FacultySection/schema'
import { cn } from '@admin/lib/utils'
import { ArrowUpRightIcon } from '@heroicons/react/24/outline'
import { Typography } from '@pw-tech/omni-ui'
import Image from 'next/image'
import { useState } from 'react'
import FacultyModal from '../FacultyModal'
import styles from './styles.module.css'

const Faculty = ({ faculty, isVisible = true }: { faculty: FacultyProps; isVisible?: boolean }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const handleDialogClose = () => {
    setIsDialogOpen(false)
  }

  return (
    <>
      <div
        className={cn('group', styles.facultyCard)}
        // Remove from tab order & assistive tech if slide not visible to satisfy Lighthouse a11y rule
        tabIndex={isVisible ? 0 : -1}
        role={isVisible ? 'button' : undefined}
        aria-hidden={isVisible ? undefined : true}
        onClick={() => (isVisible ? setIsDialogOpen(true) : undefined)}
      >
  <div className="w-full h-full right-0 absolute -bottom-16">
          <Image
            src={FACULTY_BG}
            layout='fill'
            objectFit='contain'
            className='relative -bottom-10'
            alt=''
            loading='lazy'
          />
        </div>

  <div className="flex flex-col gap-2 z-10">
          <Typography variant='heading3' weight='bold' color='#1b2124'>
            {faculty.name}
          </Typography>
          <Typography variant='small' color='#1b2124'>
            {faculty?.miniDescription}
          </Typography>
        </div>

  <div className="mt-2 flex flex-row items-center justify-start self-start overflow-hidden z-10">
          <Typography variant='small' component='span' color='#3d3d3d' weight='semi-bold'>
            Know More{' '}
          </Typography>
          <ArrowUpRightIcon
            width={14}
            height={14}
            strokeWidth={2}
            color='#3d3d3d'
            className="ml-[2px] font-semibold transition-transform duration-300"
          />
        </div>

        <div className={cn(
          'absolute -bottom-2 grayscale-[50%] transition-all duration-500 max-w-[300px] md:max-w-[570px]',
          'group-hover:scale-105'
        )}>
          {faculty?.image && (
            <Image src={faculty.image} width={570} height={581} alt={faculty.name} loading='lazy' />
          )}
        </div>
      </div>

      {isDialogOpen && <FacultyModal open={isDialogOpen} onClose={handleDialogClose} data={faculty} />}
    </>
  )
}

export default Faculty
